module.exports = __webpack_public_path__ + "img/film-threat-planning.81e968b2.jpg";